import { ProductIdent, ProductVisibility } from "@coaching-culture/types";
import { Grid } from "@coaching-culture/ui";
import { useUser } from "auth";
import CenterColumn from "components/CenterColumn";
import { PageHeader } from "components/PageHeader";
import { useAllProductVisibility } from "hooks/useProductVisibility";
import { Home } from "pages/Home";
import { DocumentsWidget } from "pages/RelationshipProfile/DocumentsWidget";
import { ActionsWidget } from "./Widgets/ActionsWidget";
import { ConversationsWidget } from "./Widgets/ConversationsWidget";
import { FeedbackWidget } from "./Widgets/FeedbackWidget";
import { GoalWidget } from "./Widgets/GoalsWidget";
import { LessonModuleWidget } from "./Widgets/LessonModuleWidget";
import { RecentConversationsWidget } from "./Widgets/RecentConversationsWidget";
import { TeamGoalWidget } from "./Widgets/TeamGoalWidget";

export function Dashboard() {
  const [user] = useUser();
  const products = useAllProductVisibility();

  const hasProduct = (ident: ProductIdent) => {
    return products[ident] === ProductVisibility.Enabled;
  };

  const couldHaveActions = (["360", "surveys", "performance"] as const).some(
    (x) => hasProduct(x),
  );

  // Orgs with the "home-v2" product get the new Home page at the same URL,
  // so bookmarks and links in emails keep working.
  if (hasProduct("home-v2")) {
    return <Home />;
  }

  return (
    <CenterColumn>
      <PageHeader text={"Dashboard"} />
      <Grid
        gridGap={[3, 3]}
        gridTemplateColumns={[
          "minmax(0, 1fr)",
          "minmax(0, 1fr)",
          "minmax(0, 1fr)",
          "minmax(0, 1fr) minmax(0, 1fr)",
        ]}
        display={["block", "grid"]}
      >
        {hasProduct("performance") && (
          <>
            <ConversationsWidget />
            <RecentConversationsWidget />
            <GoalWidget />
            <TeamGoalWidget />
            <DocumentsWidget userId={user.id} />
          </>
        )}
        {hasProduct("cont-feedback") && <FeedbackWidget />}
        {couldHaveActions && <ActionsWidget />}
        {hasProduct("mindset") && <LessonModuleWidget contentType="module" />}
        {hasProduct("lessons") && <LessonModuleWidget contentType="lesson" />}
        {hasProduct("assessments") && (
          <LessonModuleWidget contentType="assessment" />
        )}
        {hasProduct("learncast") && (
          <LessonModuleWidget contentType="learncast" />
        )}
      </Grid>
    </CenterColumn>
  );
}
